module.exports = __webpack_public_path__ + "sq2-b0999c67.png";